import { render, staticRenderFns } from "./PaymentFeesExternal.vue?vue&type=template&id=6abcbc85"
import script from "./PaymentFeesExternal.vue?vue&type=script&lang=js"
export * from "./PaymentFeesExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports